<template>
  <div>
    <div class="nav-container">
      <div class="nav-tabs">
        <div class="nav-tab" :class="{ active: selectedHour === 6 }" @click="selectHour(6)">
          6h
        </div>
        <div class="nav-tab" :class="{ active: selectedHour === 12 }" @click="selectHour(12)">
          12h
        </div>
        <div class="nav-tab" :class="{ active: selectedHour === 24 }" @click="selectHour(24)">
          24h
        </div>
      </div>
      <div class="dropdown">
        <div class="dropdown-btn">Recommended</div>
      </div>
    </div>
    <template >
      <div v-for="league in leagues" :key="league.id">
        <div class="header">
          <h2>{{ league.name }}</h2>
        </div>
        <div v-for="item in processedItems.filter(ev => ev.league_id === league.id)" :key="league + item.id" class="match-container" @click="selectGame(item)">
            <div class="match-header">
              <!-- <div class="star-icon">
                <i class="far fa-star"></i>
              </div> -->
              <div class="match-info">
                <div class="match-title" v-if="item.status === '2'">
                  스코어 입력
                </div>
                <div class="match-subtitle">{{ item.start_time | formatDate1('MM-DD HH:mm') }}</div>
              </div>
            </div>
            <div class="match-row">
              <div class="section teams">
                <div class="team-info">
                  <img class="team-logo" :src="item.teams.homeLogo" alt="Home Logo">
                  <div class="team-name">{{ item.teams.homeName }}</div>
                </div>
                <div class="team-info">
                  <img class="team-logo" :src="item.teams.awayLogo" alt="Away Logo">
                  <div class="team-name">{{ item.teams.awayName }}</div>
                </div>
              </div>
              <div class="section odds" v-for="market in getMarketsByEvent(item.id)" :key="market.id">
                <div class="odds-box" :class="{ 'horizontal': getOutcomesByMarket(market.id).length > 2 }" v-for="outcome in getOutcomesByMarket(market.id)" :key="outcome.id">
                    <span class="odds-title">{{ outcome.name }}</span>
                    <span class="odds-value">{{ outcome.betting_offer_odds }}</span>
                  </div>
              </div>
            </div>
        </div>
      </div>

    </template>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LiveSportsTable',
  components: {
  },
  props: {
    selectGame: {
      type: Function,
      required: true
    },
    selectedHour: {
      type: Number,
      required: true
    },
    selectHour: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: '경기시각', value: 'start_time' },
        { text: '종목', value: 'sport_name' },
        { text: '국가', value: 'country_name' },
        { text: '리그', value: 'league_name' },
        { text: '팀', value: 'teams' },
        { text: '더보기', value: 'more' },
      ],
      visibleDetails: [],
      selectedLeague: null,
    }
  },
  computed: {
    ...mapGetters('oddsmatrix', [
      'getEvents',
      'getMarkets',
      'getOutcomes',
      'getMarketOutcomeRelations',
      'getBettingTypes'
    ]),
    events() {
      return this.getEvents || [];
    },
    markets() {
      return this.getMarkets || [];
    },
    marketOutcomeRelation() {
      return this.getMarketOutcomeRelations || [];
    },
    outcomes() {
      return this.getOutcomes || [];
    },
    leagues() {
      // leagues가 별도 배열로 오지 않는다면 events에서 유니크 추출
      const leagueMap = new Map();
      (this.events || []).forEach(ev => {
        if (ev.league_id && ev.league_name) {
          leagueMap.set(ev.league_id, { id: ev.league_id, name: ev.league_name });
        }
      });
      return Array.from(leagueMap.values());
    },
    filteredItems() {
      // Filter items by selected league
      if (this.selectedLeague) {
        return this.events.filter(item => item.league_name === this.selectedLeague);
      }
      return this.events;
    },
    processedItems() {
      return this.filteredItems.map(item => {
        const homeParticipant = item.participants?.find(p => p.participant_role_name === 'Home');
        const awayParticipant = item.participants?.find(p => p.participant_role_name === 'Away');
        // Process team logos and names
        const teams = {
          homeLogo: homeParticipant?.participant_logo_url || 'https://static-sdsoft.s3.ap-northeast-1.amazonaws.com/shiled.png',
          homeName: homeParticipant?.participant_name || item.name?.split(' vs ')[0],
          awayLogo: awayParticipant?.participant_logo_url || 'https://static-sdsoft.s3.ap-northeast-1.amazonaws.com/shiled.png',
          awayName: awayParticipant?.participant_name || item.name?.split(' vs ')[1]
        };
        // Process scores and other details
        const score = {
          home: null,
          away: null
        };
        // Return processed item structure
        return {
          id: item.id,
          start_time: item.start_time,
          sport_name: item.sport_name,
          status: item.status,
          country_name: item.country_name,
          league_name: item.league_name,
          league_id: item.league_id,
          teams,
          score,
          winner: item.winner,
          handicap: item.handicap,
          totalRounds: item.totalRounds
        };
      });
    }
  },
  methods: {
    toggleDetail(item) {
      const index = this.visibleDetails.findIndex(id => id === item.id)
      if (index >= 0) {
        this.visibleDetails.splice(index, 1);
      } else {
        this.visibleDetails.push(item.id);
      }
    },
    isDetailVisible(item) {
      return this.visibleDetails.includes(item.id);
    },
    getMarketsByEvent(eventId) {
      // 해당 경기(eventId)에 연결된 마켓만 반환
      return this.markets.filter(market => market.event_id === eventId);
    },
    getOutcomesByMarket(marketId) {
      // 해당 마켓에 연결된 outcome_id만 반환
      const relations = this.marketOutcomeRelation.filter(rel => rel.market_id === marketId);
      const outcomeIds = relations.map(rel => rel.outcome_id);
      return this.outcomes.filter(outcome => outcomeIds.includes(outcome.id));
    },
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        // Update leagues whenever items change
        this.leagues = this.uniqueLeagues;
      }
    }
  }
}
</script>


<style scoped>
.nav-container, .header, .match-container {
  background-color: #1e1e1e;
  margin-bottom: 10px;
  border-radius: 5px;
  overflow: hidden;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.nav-tabs {
  display: flex;
}

.nav-tab {
  padding: 10px 20px;
  margin-right: 5px;
  background-color: #2a2a2a;
  cursor: pointer;
  border-radius: 2px;
  transition: background-color 0.3s ease;
}

.nav-tab:hover {
  background-color: #3a3a3a;
}

.nav-tab.active {
  background-color: #3a3a3a;
}

.dropdown {
  display: flex;
  align-items: center;
}

.dropdown-btn {
  padding: 10px 15px;
  background-color: #2a2a2a;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 2px;
}

.dropdown-btn:hover {
  background-color: #3a3a3a;
}

.dropdown-btn::after {
  content: "▼";
  margin-left: 5px;
  font-size: 10px;
}

.header {
  padding: 15px;
  display: flex;
  align-items: center;
}

.header img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.match-container {
  margin-bottom: 10px;
}

.match-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #2a2a2a;
}

.star-icon {
  margin-right: 15px;
  color: white;
  font-size: 20px;
}

.match-info {
  flex-grow: 1;
}

.match-title {
  display: flex;
  align-items: center;
}

.video-icon {
  color: #ff4500;
  margin-left: 5px;
}

.match-subtitle {
  color: #999;
  font-size: 14px;
  margin-top: 3px;
}

.match-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px 15px;
  border-bottom: 1px solid #2a2a2a;
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 15%;
}

.section.teams {
  width: 70%;
}

.team-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.team-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
}

.team-name {
  flex-grow: 1;
}

.team-score {
  color: #4a9eff;
  font-weight: bold;
  margin-right: 15px;
  width: 30px;
  text-align: right;
}

.team-score.red {
  color: #ff6b6b;
}

.result {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #000;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.section.odds {
  height: 100px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.odds-box {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  background-color: #2a2a2a;
  border: 1.5px solid #444;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
  text-align: center;
  padding: 6px 0;
  min-height: 0;
  min-width: 0;
  gap: 2px;
}

.odds-box:hover {
  background-color: #3a3a3a;
  border-color: #a97bf5;
}

.odds-title {
  font-weight: bold;
  font-size: 13px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

.odds-value {
  color: #a095c7;
  font-weight: bold;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

.green-arrow {
  color: #4CAF50;
}

.red-arrow {
  color: #f44336;
}

.time {
  font-size: 18px;
  font-weight: bold;
}

.date {
  color: #999;
  font-size: 14px;
}

.odds-box.horizontal {
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
}

.odds-box.horizontal .odds-title {
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}

.odds-box.horizontal .odds-value {
  font-size: 15px;
  color: #a095c7;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40%;
}
</style> 